import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(() => ({
  label: {
    flex: "0 0 180px",
    color: grey[600],
    textTransform: "uppercase",
  },
  value: {
    flex: 3,
    fontWeight: 400,
  },
  actionPanel: {
    width: "48px",
    display: "flex",
    justifyContent: "flex-end",
  },
}));
